import { render, staticRenderFns } from "./VenueGoogleMap.vue?vue&type=template&id=4874d80c"
import script from "./VenueGoogleMap.vue?vue&type=script&lang=js"
export * from "./VenueGoogleMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports